import { h } from 'preact';

export const ReferralIcon = () => (
  <svg width="29" height="19" viewBox="0 0 29 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.5"
      d="M28 18H10C11.5349 12.8013 13.3944 11.053 19 10.5C23.9324 10.9119 26.0458 12.3443 28 18Z"
      fill="#97AA5C"
      stroke="white"
      stroke-width="0.5"
    />
    <path
      d="M19 18H1C2.53494 12.8013 4.39443 11.053 10 10.5C14.9324 10.9119 17.0458 12.3443 19 18Z"
      fill="#97AA5C"
      stroke="white"
      stroke-width="0.5"
    />
    <circle
      opacity="0.5"
      cx="19"
      cy="6"
      r="5.75"
      fill="#97AA5C"
      stroke="white"
      stroke-width="0.5"
    />
    <circle cx="10" cy="6" r="5.75" fill="#97AA5C" stroke="white" stroke-width="0.5" />
  </svg>
);
